import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from 'react-router-dom';
import './ForgotPasswordOTP.css';
import {api, ENDPOINTS } from '../../services/apiConfig'


const ForgotPasswordOTP = () => {




    const [otp, setOtp] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();

    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        
        if (!otp.trim()) {
            toast.error(
                <div className="toast-content">
                    <i className="fas fa-exclamation-triangle"></i>
                    <span>Please enter the OTP code</span>
                </div>,
                {
                    position: 'top-center',
                    autoClose: 3000,
                }
            );
            return;
        }
        
        setIsSubmitting(true);

        try {
            // Retrieve the JWT token from sessionStorage
            const jwtToken = sessionStorage.getItem('token');

            // Add the token to the request headers
            const response = await api.vendor.post(
                ENDPOINTS.vendor.forgotpasswordotp, 
                { otp },
                {
                    headers: {
                        'Authorization': `Bearer ${jwtToken}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            toast.success(
                <div className="toast-content">
                    <i className="fas fa-check-circle"></i>
                    <span>OTP verified successfully!</span>
                </div>,
                {
                    position: "top-center",
                    autoClose: 2000,
                    onClose: () => {
                        navigate('/new-password', { replace: true });
                    }
                }
            );
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'An unexpected error occurred. Please try again.';
            
            toast.error(
                <div className="toast-content">
                    <i className="fas fa-exclamation-triangle"></i>
                    <span>{errorMessage}</span>
                </div>,
                {
                    position: 'top-center',
                    autoClose: 3000,
                }
            );
            console.error('OTP verification error:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="otp-verification-body">
            <ToastContainer />
            <div className="otp-verification-container">
                <div className="logo-container">
                    <img src="/assets/genie.png" alt="Genie Logo" className="login-logo" />
                </div>
                <h1>Forgot Password</h1>
                <p className="subtitle">Please enter the OTP sent to your email</p>
                
                <form onSubmit={handleVerifyOtp}>
                    <div className="form-group">
                        <label htmlFor="otp" className="form-label">
                            <i className="fas fa-key"></i>
                            <span>One-Time Password (OTP)</span>
                        </label>
                        <div className="input-container">
                            <i className="fas fa-key input-icon"></i>
                            <input
                                type="text"
                                id="otp"
                                placeholder="Enter 4-digit OTP"
                                value={otp}
                                onChange={(e) => setOtp(e.target.value)}
                                maxLength={6}
                                required
                            />
                        </div>
                    </div>
                    <button 
                        type="submit" 
                        className="otpverify-submit-button"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? (
                            <span className="button-content">
                                <i className="fas fa-spinner fa-spin"></i>
                                <span>Verifying...</span>
                            </span>
                        ) : 'Verify OTP'}
                    </button>
                    <div className="back-link">
                        <button 
                            type="button"
                            onClick={() => navigate('/forgot-password')}
                            className="back-button"
                        >
                            <i className="fas fa-arrow-left"></i>
                            <span>Back to Forgot Password</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ForgotPasswordOTP;